import { a as authServer } from "../../../../../chunks/auth-server.js";
const handler = async (requestEvent) => {
  const response = await authServer.handler(requestEvent.request);
  return response;
};
const GET = handler;
const POST = handler;
export {
  GET,
  POST
};
